import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateConferencePayload } from '@app-store/slices/conferences/createConference'

interface TaskAction extends Action {
    payload: ICreateConferencePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.conferences.create

function* createConferenceSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/event/conference`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* createConferenceSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createConferenceSagaTask)
}

export default createConferenceSaga
